<footer>
    <div class="cpy-right text-center py-4">
        <p class="text-white">© 2021 Vikas Gupta. All rights reserved.
        </p>
    </div>
</footer>